jQuery('#logo-slider').owlCarousel({
    loop:true,
    margin:15,
    nav:false,
  dots:false,
  autoplay:true,
autoplayTimeout:2000,
autoplayHoverPause:true,
    responsive:{
        0:{
            items:2
        },
        600:{
            items:3
        },
        1000:{
            items:6
        }
    }
});

jQuery('#page-slider').owlCarousel({
    loop:true,
    margin:20,
  dots:false,
    nav:false,
  autoplay:true,
autoplayTimeout:2000,
autoplayHoverPause:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
});